import {createErrorAction} from './utils';

const TYPES = {
    GET_GAMES: 'GET_GAMES',
    GET_GAMES_COMPLETE: 'GET_GAMES_COMPLETE',
    GET_GAMES_FAILED: 'GET_GAMES_FAILED'
};

export default {
    TYPES,

    getGames: payload => ({
        type: TYPES.GET_GAMES,
        payload
    }),

    getGamesSuccess: payload => ({
        type: TYPES.GET_GAMES_COMPLETE,
        payload
    }),

    getGamesFailed: createErrorAction(TYPES.GET_GAMES_FAILED)
};
